.container {
  margin-top: 1.6rem;
  display: flex;
  // justify-content: space-between;
  max-width: 100%;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  height: 100%;
  padding-bottom: 1.6rem;
  gap: 1.6rem;
}
